export default {
    state: {
        customers: {
            schedule: "all",
            estimator: "all",
            status: "all",
            assign: "all",
            keyword: "",
            phone: "",
            daterange: "",
            type: ""
        },
        leads: {
            schedule: "all",
            estimator: "all",
            status: "all",
            assign: "all",
            keyword: "",
            phone: "",
            daterange: ""
        },
        jobs: {
            job_no: "",
            keyword: "",
            status: ["active", "completed"],
            foreman: "all"
        },
        deposits: {
            job_no: "",
            keyword: "",
            status: ["active", "completed"],
            user: "all",
            county: "",
            priority: ["low", "medium", "high", "urgent"],
            daterange: "",
            order: true
        },
        workorders: {
            job_no: "",
            keyword: "",
            status: ["active"],
            user: "all",
            priority: ["low", "medium", "high", "urgent"],
            daterange: "",
            county: "",
            order: false
        },
        punchlist: {
            job_no: "",
            keyword: "",
            status: ["active"],
            user: "all",
            county: "",
            priority: ["low", "medium", "high", "urgent"],
            daterange: "",
            order: false
        },
        pagination: []
    },
    getters: {

    },
    mutations: {
        SET_CUSTOMERS_FILTER : (state,payload) => {
            state.customers = payload
        },
        SET_LEADS_FILTER : (state,payload) => {
            state.leads = payload
        },
        SET_JOBS_FILTER : (state,payload) => {
            state.jobs = payload
        },
        SET_DEPOSITS_FILTER : (state,payload) => {
            state.deposits = payload
        },
        SET_WORKORDERS_FILTER : (state,payload) => {
            state.workorders = payload
        },
        SET_PUNCHLIST_FILTER : (state,payload) => {
            state.punchlist = payload
        },
        SET_PAGINATION(state, payload) {
            state.pagination = payload
        },
    },
    actions: {

    }
}